/**
 * 管理台 API 根地址（与 app.tsx request.baseURL 一致）。
 * 测试：build:test → REACT_APP_API_BASE_URL 或 tadmin.* → tapi.*
 * 正式 A：admin.* → api.*
 * 正式 B：bueatyadmin.* → bueatyapi.*
 *
 * 注意：mako define 可能对 JSON.stringify 后再包一层引号，运行时需剥掉，
 * 否则会变成相对路径打到管理台域名，POST 被 nginx 回 405 HTML。
 */
export function resolveAdminApiBaseUrl(): string {
  const envBase = String(process.env.REACT_APP_API_BASE_URL ?? '')
    .replace(/^["']+|["']+$/g, '')
    .trim();
  if (envBase && /^https?:\/\//i.test(envBase)) {
    return envBase.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    if (hostname.startsWith('tadmin.')) {
      return `${protocol}//${hostname.replace(/^tadmin\./, 'tapi.')}/admin`;
    }
    if (hostname.startsWith('bueatyadmin.')) {
      return `${protocol}//${hostname.replace(/^bueatyadmin\./, 'bueatyapi.')}/admin`;
    }
    if (hostname.startsWith('admin.')) {
      return `${protocol}//${hostname.replace(/^admin\./, 'api.')}/admin`;
    }
  }
  return '/admin';
}
